var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_265_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4624 0.03125C45.4106 0.0270508 45.3667 0 45.3125 0H22.9168C19.471 0 16.6668 2.8042 16.6668 6.25V8.3332C16.6668 9.4833 17.5999 10.4168 18.75 10.4168C19.9001 10.4168 20.8332 9.4833 20.8332 8.3332V6.25C20.8332 5.10215 21.7686 4.1668 22.9168 4.1668H32.6229L31.9874 4.3793C30.3001 4.9625 29.1668 6.55215 29.1668 8.3332V39.5832H22.9168C21.7686 39.5832 20.8332 38.6479 20.8332 37.5V33.3332C20.8332 32.1835 19.9001 31.25 18.75 31.25C17.5999 31.25 16.6668 32.1835 16.6668 33.3332V37.5C16.6668 40.9458 19.471 43.75 22.9168 43.75H29.1668V45.8332C29.1668 48.1312 31.0353 50 33.3332 50C33.7791 50 34.2022 49.9355 34.6604 49.7937L47.1772 45.6208C48.8666 45.0375 50 43.4479 50 41.6668V4.1668C50 1.7376 47.9062 -0.166699 45.4624 0.03125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3061 19.3604L13.9729 11.0271C13.6815 10.7355 13.3103 10.5369 12.906 10.4565C12.5018 10.376 12.0827 10.4173 11.702 10.5751C11.3217 10.7333 10.9967 11.0005 10.768 11.343C10.5393 11.6855 10.4171 12.0881 10.4168 12.5V18.75H2.0832C0.933496 18.75 0 19.6835 0 20.8332C0 21.9833 0.933496 22.9168 2.0832 22.9168H10.4168V29.1668C10.4172 29.5786 10.5394 29.9812 10.7681 30.3237C10.9968 30.6662 11.3217 30.9334 11.702 31.0916C12.0827 31.2493 12.5017 31.2906 12.906 31.2101C13.3102 31.1297 13.6815 30.9312 13.9729 30.6396L22.3061 22.3061C23.1209 21.4916 23.1209 20.1752 22.3061 19.3604Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_265_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLight);
export default __webpack_public_path__ + "static/media/login-light.e98c7501b6c916bb52ec2b12f1146f88.svg";
export { ForwardRef as ReactComponent };